import { privateClient } from "@/api/privateClient";
import { INSTITUTION_ADMIN_ENDPOINTS } from "../../institutionAdmin.endpoints";
import type { PromotionPreviewStudent, PromotionBatch, PromotionBatchResult, PromotionConfirmOptions, PromotionItemResult } from "../types";

const PROMOTIONS = INSTITUTION_ADMIN_ENDPOINTS.PROMOTIONS;

export async function fetchPromotionBatches(institutionId: number, params?: { fromAcademicYearId?: number }): Promise<PromotionBatch[]> {
  const { data } = await privateClient.get(PROMOTIONS.BATCHES.LIST(institutionId), { params });
  return data.batches ?? [];
}

export async function fetchPromotionPreview(
  institutionId: number,
  params: { fromAcademicGroupId: number; fromAcademicYearId: number; examId?: number }
): Promise<PromotionPreviewStudent[]> {
  const { data } = await privateClient.get(PROMOTIONS.PREVIEW(institutionId), { params });
  return data.students ?? [];
}

export async function createPromotionBatch(
  institutionId: number,
  payload: { fromAcademicGroupId: number; fromAcademicYearId: number; toAcademicYearId: number; examId?: number }
): Promise<PromotionBatchResult> {
  const { data } = await privateClient.post(PROMOTIONS.BATCHES.CREATE(institutionId), payload);
  return data;
}

export async function fetchPromotionBatch(institutionId: number, batchId: number): Promise<PromotionBatchResult> {
  const { data } = await privateClient.get(PROMOTIONS.BATCHES.GET(institutionId, batchId));
  return data;
}

export async function updatePromotionItem(
  institutionId: number,
  batchId: number,
  itemId: number,
  payload: { result: PromotionItemResult; toAcademicGroupId?: number; examId?: number }
): Promise<PromotionBatchResult> {
  const { data } = await privateClient.patch(PROMOTIONS.ITEMS.UPDATE(institutionId, batchId, itemId), payload);
  return data;
}

export async function revertPromotionBatch(institutionId: number, batchId: number, itemIds?: number[]): Promise<PromotionBatchResult> {
  const { data } = await privateClient.post(PROMOTIONS.BATCHES.REVERT(institutionId, batchId), { itemIds });
  return data;
}

export async function confirmPromotionBatch(
  institutionId: number,
  batchId: number,
  options: PromotionConfirmOptions = {}
): Promise<PromotionBatchResult> {
  const { data } = await privateClient.post(PROMOTIONS.BATCHES.CONFIRM(institutionId, batchId), options);
  return data;
}
